export default __webpack_public_path__ + "static/media/notification.1635d3cf.svg";